import React from 'react';

export default function Preview({ image }) {
  return (
    <div className={'product__image'}>
      <img src={image} alt={'product'} />
    </div>
  );
}
